import React, { FC } from 'react';
import { ReactComponent as ArrowIcon } from '../../../../../assets/arrowLeft.icon.svg';

import useStyles from '../styles';
import cx from 'classnames';
import { tt } from '@i18n/tt';

export enum ButtonType {
  Next = 'Next',
  Previous = 'Previous',
}
interface IProps {
  buttonType: ButtonType;
}
const PaginationButton: FC<IProps> = ({ buttonType }) => {
  const classes = useStyles();
  const buttonText = {
    [ButtonType.Next]: tt('table.next'),
    [ButtonType.Previous]: tt('table.previous'),
  };

  return (
    <div className={classes.paginationButton}>
      {buttonType === ButtonType.Previous && <ArrowIcon />}
      {buttonText[buttonType]}
      {buttonType === ButtonType.Next && <ArrowIcon className={classes.paginationArrow} />}
    </div>
  );
};

export default PaginationButton;
